import React from 'react';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { Link } from 'react-router-dom'
/* import Link from '@mui/material/Link'; */
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { createTheme, ThemeProvider } from '@mui/material/styles';
/* import Copyright from '../../components/Copyright/Copyright'; */
import { Layout, AdBlock, AdImage } from '../../../components/index';


const RegistroUsuariosView = ({ formik, loading, error, acepto_terminos_y_condiciones, terminos_y_condiciones }) => {

    const theme = createTheme({
        typography: {
            fontSize: 14,
        },
        spacing: 13
    });

    return (
        <Layout background="#1f2024">
            <ThemeProvider theme={theme}>
                <Container component="main" maxWidth="xs">
                    <CssBaseline />
                    <Box
                        sx={{
                            marginTop: 8,
                            marginBottom: 8,
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                        }}
                    >
                        <Avatar sx={{ m: 2, bgcolor: 'primary.main', width: "60px", height: "60px" }} />

                        <Typography component="h1" variant="h5">
                            Registrarme
                        </Typography>
                        <Box component="form" noValidate onSubmit={formik.handleSubmit} sx={{ mt: 3 }}>
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        autoComplete="given-name"
                                        name="nombre"
                                        required
                                        fullWidth
                                        id="nombre"
                                        label="Ingresa tu nombre"
                                        autoFocus
                                        size="small"

                                        value={formik.values.nombre}
                                        onChange={formik.handleChange}
                                        error={formik.touched.nombre && formik.errors.nombre}
                                        helperText={formik.touched.nombre && formik.errors.nombre}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        required
                                        fullWidth
                                        id="apellido"
                                        label="Ingresa tu apellido"
                                        name="apellido"
                                        autoComplete="family-name"
                                        size="small"
                                        value={formik.values.apellido}
                                        onChange={formik.handleChange}
                                        error={formik.touched.apellido && formik.errors.apellido}
                                        helperText={formik.touched.apellido && formik.errors.apellido}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        required
                                        fullWidth
                                        id="email"
                                        label="Correo electrónico"
                                        name="email"
                                        autoComplete="email"
                                        size="small"
                                        value={formik.values.email}
                                        onChange={formik.handleChange}
                                        error={formik.touched.email && formik.errors.email}
                                        helperText={formik.touched.email && formik.errors.email}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        required
                                        fullWidth
                                        name="password"
                                        label="Contraseña"
                                        type="password"
                                        id="password"
                                        size="small"
                                        value={formik.values.password}
                                        onChange={formik.handleChange}
                                        error={formik.touched.password && formik.errors.password}
                                        helperText={formik.touched.password && formik.errors.password}
                                    />
                                </Grid>
                                <Grid item xs={12} >
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                value="terminos_y_condiciones"
                                                color="primary"
                                                onClick={() => {
                                                    if (terminos_y_condiciones) {
                                                        acepto_terminos_y_condiciones(false)
                                                    } else {
                                                        acepto_terminos_y_condiciones(true)
                                                    }
                                                }}
                                            />}
                                        label="Acepto terminos y condiciones."
                                    />
                                </Grid>
                            </Grid>
                            {
                                terminos_y_condiciones
                                    ? <Button
                                        type="submit"
                                        fullWidth
                                        variant="contained"
                                        sx={{ mt: 3, mb: 2 }}
                                    >
                                        Registrarme
                                    </Button>
                                    : null
                            }

                            <Grid container justifyContent="flex-end">
                                <Grid item>
                                    <Link to="/login/usuarios" >
                                        ¿Ya tenes una cuenta? Inicia Sesión
                                    </Link>
                                </Grid>
                            </Grid>
                        </Box>
                    </Box>

                </Container>
            </ThemeProvider >
        </Layout>
    )
}

export default RegistroUsuariosView;
